import { Fragment } from 'react';
import DocumentRow from './document-row';
// import DocumentBlock from './document-block';
import { DocumentsItemsTypes } from './types';

import cn from './documents.module.css';

const DocumentsItems = ({
  documents,
  onSelect,
  type,
  // blockView,
  customerId,
  customerType,
  setRenamePopupVisible,
  setSelectedDocumentToRename,
  status,
  updateExpiredDocumentsState,
}: DocumentsItemsTypes): React.JSX.Element => (
  <div
    // ${blockView ? cn.documentsItemsWrapperFlex : ''}
    className={`
    ${cn.documentsItemsWrapper} 
   `}
  >
    {documents?.map((item) => (
      <Fragment key={item.id}>
        {/* {!blockView ? ( */}
        <DocumentRow
          document={item}
          onSelect={onSelect}
          type={type}
          lastChild={Boolean(documents.length === 1)}
          customerId={customerId}
          customerType={customerType}
          setRenamePopupVisible={setRenamePopupVisible}
          setSelectedDocumentToRename={setSelectedDocumentToRename}
          status={status}
          updateExpiredDocumentsState={updateExpiredDocumentsState}
        />
        {/* ) : (
          <DocumentBlock
            document={item}
            onSelect={onSelect}
            type={type}
            setDragState={setDragState}
            setDragActiveBlock={setDragActiveBlock}
            selectedDocumentType={dragState.type}
            selectedDocumentsCount={selectedDocumentsCount}
            customerId={customerId}
            customerType={customerType}
          />
        )} */}
      </Fragment>
    ))}
  </div>
);

export default DocumentsItems;
